export { default } from "./RichTextList";
